import { Typography } from "@chr/eds-react";
import { useTranslation } from "@chr/online-shared-ui-localizations";
import { Box, Grid, Stack } from "@mui/material";
import { IsoToDate, ConvertToMultiWordString } from "../../common/utilities/display-utilities";

export interface CustomsSummaryProps {
  customsStatus?: string;
  destinationDate?: string;
  isMobileScreen: boolean;
}

export const CustomsSummary = ({ customsStatus, destinationDate, isMobileScreen }: CustomsSummaryProps) => {

  const translate = useTranslation();

  const customsStatusText = customsStatus ? ConvertToMultiWordString(customsStatus) : '';
  const destinationDateText = destinationDate ?? '';

  const CustomsSummaryItem = (title: string, value: string) => {
    return (
      <Stack
        direction={isMobileScreen ? 'row' : 'column'}
        justifyContent={isMobileScreen ? 'space-between' : 'flex-start'}
        spacing={isMobileScreen ? 2 : 1}
        width={'100%'}
        sx={{
          padding: isMobileScreen ? "10px 15px 0px 20px" : "10px 15px 15px 35px"
        }}
      >
        <Typography variant="body1">{title}</Typography>
        <Typography variant="subtitle2">{value}</Typography>
      </Stack>
    )
  };

  return (
    <Box data-testid="customs-summary"
      sx={{
        border: '1px solid #E5E6E7',
        borderRadius: '4px',
        backgroundColor: '#FFF',
      }}
    >
      <Box
        sx={{
          backgroundColor: '#F5F6F7',
          padding: '8px 16px',
          borderRadius: '2px 2px 0 0',
        }}
      >
        <Typography variant="h3">{translate('Customs Summary')}</Typography>
      </Box>
      <Grid
        container
        spacing={2}
        data-testid="customs-summary-items-section"
        alignItems={'flex-start'}
        justifyContent={'flex-start'}
        sx={{ padding: isMobileScreen ? "15px 0px 15px 0px" : "15px 0px 15px 5px"}}
      >
        <Grid item xs={isMobileScreen ? 12 : 2} sx={{ padding: isMobileScreen ? "25px 0px 0px 0px" : undefined}}>
          {CustomsSummaryItem(translate('Status'), customsStatusText)}
        </Grid>
        <Grid item xs={isMobileScreen ? 12 : 2} sx={{ padding: isMobileScreen ? "0px 0px 15px 0px" : undefined}}>
          {CustomsSummaryItem(translate('Date'), IsoToDate(destinationDateText))}
        </Grid>
      </Grid>
    </Box>
  );
};

